import React from 'react';
import { Col, Row, Space, Typography } from 'antd';
const { Title, Text } = Typography;
const PageHeader = (props) => {
	return (
		<Row align="top" style={{ marginBottom: '10px' }}>
			<Col>
				<Space align="start">
					<div>
						<Title level={4} style={{ margin: 0 }}>
							{props.title}
						</Title>
					</div>
				</Space>
			</Col>
			<Col flex="auto" style={{ textAlign: 'right' }}>
				<Space align="bottom">{props.extra}</Space>
			</Col>
		</Row>
	);
};

export default PageHeader;
